module.exports = __webpack_public_path__ + "static/media/p2.1dda4a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/p2.svg
// module id = 122
// module chunks = 6